module.exports = "../../static/img/hearingtest-screenshot-en-us.d0dab9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hearingtest-screenshot-en-us.png
// module id = o9gB
// module chunks = 1